import { Button } from 'semantic-ui-react';
import moment from 'moment';
import { agGridDateCreatedAtFieldComparator } from '../../table/helpers';

export const getNewMembersColumnDefs = (onView) => [
  {
    headerName: 'Fecha',
    field: 'createdAt',
    width: 120,
    comparator: agGridDateCreatedAtFieldComparator,
    cellRenderer: (params) => {
      const { value } = params;
      if (!value) return '';
      return moment.tz(value, 'America/Bogota').format('DD-MM-YYYY');
    },
  },
  {
    headerName: 'Hora',
    field: 'createdAt',
    width: 100,
    sortable: false,
    filter: false,
    cellRenderer: (params) => {
      const { value } = params;
      if (!value) return '';
      return moment.tz(value, 'America/Bogota').format('hh:mm a');
    },
  },
  {
    headerName: 'Nombre',
    field: 'Guest.name',
    width: 150,
    cellRenderer: (params) => {
      const { data } = params;
      return data?.Guest?.name || '';
    },
  },
  {
    headerName: 'Apellido',
    field: 'Guest.lastName',
    width: 150,
    cellRenderer: (params) => {
      const { data } = params;
      return data?.Guest?.lastName || '';
    },
  },
  {
    headerName: 'Celular',
    field: 'Guest.phone',
    width: 130,
    cellRenderer: (params) => {
      const { data } = params;
      return data?.Guest?.phone || '';
    },
  },
  {
    headerName: 'Género',
    field: 'Guest.gender',
    width: 100,
    cellRenderer: (params) => {
      const { data } = params;
      if (!data) return '';
      return data?.Guest?.gender || 'No especificado';
    },
  },
  {
    headerName: 'Canal de contacto',
    field: 'preferredContact',
    width: 100,
    cellRenderer: (params) => {
      const { data } = params;
      if (!data) return '';
      return data?.preferredContact || 'No especificado';
    },
  },
  {
    headerName: 'Contactado',
    field: 'contacted',
    width: 120,
    cellRenderer: (params) => {
      const { data, value } = params;
      if (!data) return '';
      return Boolean(value) ? 'Si' : 'No';
    },
  },
  {
    headerName: 'Acciones',
    field: 'id',
    width: 100,
    sortable: false,
    filter: false,
    cellRenderer: (params) => {
      const { data } = params;
      if (!data) return '';
      return <Button onClick={() => onView(data)}>Ver</Button>;
    },
  },
];

const NewMembersRow = (props) => {
  const { newMember, set_showNewMembers } = props;

  const { id, createdAt, contacted, Guest, callchecks } = newMember;

  const { name, lastName, phone } = Guest;
  return (
    <tr>
      <td>{moment.tz(createdAt, 'America/Bogota').format('DD-MM-YYYY')}</td>
      <td>{moment.tz(createdAt, 'America/Bogota').format('hh:mm a')}</td>
      <td>
        <p style={{ margin: '0' }}>{name}</p>
      </td>
      <td>
        <p style={{ margin: '0' }}>{lastName}</p>
      </td>
      <td>
        <p style={{ margin: '0' }}>{phone}</p>
      </td>
      <td>
        <p style={{ margin: '0' }}>{Boolean(contacted) ? 'Si' : 'No'}</p>
      </td>
      <td>
        <p style={{ margin: '0' }}>
          {Object.values(callchecks || {}).some((f) => f) ? 'Si' : 'No'}
        </p>
      </td>
      <td>
        <Button onClick={() => set_showNewMembers(id)}>Ver</Button>
      </td>
    </tr>
  );
};

export default NewMembersRow;
